<template>
    <div class='detailpage'>
    <div class='breadcrumb'>
      <div class='content'>
        <img class='homelogo' src='../assets/img/home.png'>
        <span>当前位置： </span>
        <span>首页</span>
        >
        <span>详情</span>
      </div>
    </div>
    <div class='z_detail'>
      <div class="DZJJ" v-if="type == 10||type == 1">
        <div class="timeul" style="text-align: center;height: 50px;">
          <el-radio-group v-model="value" button-style="solid" style="margin-bottom: 15px;margin-right: -5px;">
            <el-radio-button label="1" @change.native="ViewBJ()">一次报价<div class="shixin" style="display:none"></div></el-radio-button>
            <el-radio-button label="10" :disabled="isResult" @change.native="ViewJG()">采购结果<div class="shixin" style="display:none"></div></el-radio-button>
          </el-radio-group>
          <el-timeline mode="right" style="margin: auto;margin-top: -147px;width: 35px;padding-top: 97px;">
            <el-timeline-item>
              <template #dot>
              <i v-if="value!=1" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
              <!-- <img v-if="value!=1" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px"> -->
              <i v-if="value==1"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
              </template>
                <span :style="value==21?'color:#175ec6;':''">{{datetime1}}</span>
            </el-timeline-item>
            <el-timeline-item>
              <template #dot>
              <i v-if="value!=10&&!isResult" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
              <img v-if="value!=10&&isResult" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
              <i v-if="value==10"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
              </template>
                <span :style="value==24?'color:#175ec6;':''">{{datetime3}}</span>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div v-if="!type || type == 99">
        <div class="timeul" v-if="isNotice" style="text-align: center;height: 280px;">
        <!-- <el-radio-group v-model="value" button-style="solid" style="margin-bottom: 15px;margin-right: -5px;"> -->
        <el-radio-group v-model="value" button-style="solid" style="margin-right: -5px;">
            <el-radio-button label="21" :disabled="datetime1.length>2?false:true" @change.native="GetBulletData(bulletinId1)">采购公告<div class="shixin" style="display:none"></div></el-radio-button>
            <el-radio-button label="25" :disabled="datetime4.length>2?false:true" @change.native="GetBulletData(bulletinId4)">论证公告<div class="shixin" style="display:none"></div></el-radio-button>
            <el-radio-button label="23" :disabled="datetime2.length>2?false:true" @change.native="change<2?GetBulletData(bulletinId2):GetBulletData(ChangeMentList[0].autoId)">更正公告<div class="shixin" style="display:none"></div></el-radio-button>
            <!-- <el-radio-button label="22" :disabled="datetime3.length>2?false:true" @change.native="GetBulletData(bulletinId3)">结果公告<div class="shixin" style="display:none"></div></el-radio-button> -->
            <el-radio-button label="22" :disabled="datetime3.length>2?false:true" @change.native="changeJG<2?GetBulletData(bulletinId3):GetBulletData(JGMentList[0].autoId)">候选人公示<div class="shixin" style="display:none"></div></el-radio-button>
            <el-radio-button label="24" :disabled="datetime6.length>2?false:true" @change.native="GetBulletData(bulletinId6)">结果公告<div class="shixin" style="display:none"></div></el-radio-button>
            <el-radio-button label="26" :disabled="datetime5.length>2?false:true" @change.native="GetBulletData(bulletinId5)">异常公告<div class="shixin" style="display:none"></div></el-radio-button>
          </el-radio-group>
        <!-- <el-timeline mode="right" style="margin: auto;margin-top: -232px;width: 35px;padding-top: 5px;"> -->
        <el-timeline mode="right" style="margin: auto;margin-top: -319px;width: 35px;padding-top: 5px;">
          <el-timeline-item>
            <template #dot>
            <i v-if="value!=21&&datetime1.length>2" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
            <img v-if="value!=21&&datetime1.length<2" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
            <i v-if="value==21"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
            </template>
              <span :style="value==21?'color:#175ec6;':''">{{datetime1}}</span>
          </el-timeline-item>
          <!-- <el-timeline-item style="height: 125px;"> -->
          <el-timeline-item>
            <template #dot>
            <i v-if="value!=25&&datetime4.length>2" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
            <img v-if="value!=25&&datetime4.length<2" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
            <i v-if="value==25"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
            </template>
              <span :style="value==25?'color:#175ec6;':''">{{datetime4}}</span>
          </el-timeline-item>
          <el-timeline-item>
            <template #dot>
            <i v-if="value!=23&&datetime2.length>2" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
            <img v-if="value!=23&&datetime2.length<2" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
            <i v-if="value==23"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
            </template>
              <span :style="value==23?'color:#175ec6;':''">{{datetime2}}</span>
          </el-timeline-item>
          <el-timeline-item>
            <template #dot>
            <i v-if="value!=22&&datetime3.length>2" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
            <img v-if="value!=22&&datetime3.length<2" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
            <i v-if="value==22"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
            </template>
              <span :style="value==22?'color:#175ec6;':''">{{datetime3}}</span>
          </el-timeline-item>
          <el-timeline-item>
            <template #dot>
            <i v-if="value!=24&&datetime6.length>2" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
            <img v-if="value!=24&&datetime6.length<2" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
            <i v-if="value==24"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
            </template>
              <span :style="value==24?'color:#175ec6;':''">{{datetime6}}</span>
          </el-timeline-item>
          <el-timeline-item class="Lastli">
            <template #dot>
            <i v-if="value!=26&&datetime5.length>2" style="transform: rotate(90deg);font-size: 28px;color: #175ec6" className="bid-card-svg" class="el-icon-circle-check" />
            <img v-if="value!=26&&datetime5.length<2" src="../assets/icons/svg/timenull.svg" alt="" style="height:26px">
            <i v-if="value==26"  style="transform: rotate(90deg);font-size: 32px;color: #175ec6;border: 1px solid;border-radius: 50%;" className="bid-card-svg" class="el-icon-success" />
            </template>
              <span :style="value==26?'color:#175ec6;':''">{{datetime5}}</span>
          </el-timeline-item>
        </el-timeline>
    </div>
    <div :style="isNotice?'margin-top:-165px;':''">
      <el-table  v-if="(value==23&&change>1)||(value==22&&changeJG>1)" style="width: 80%;margin:auto;" border :data="value=='23'?ChangeMentList:JGMentList" :pagination="false">
          <el-table-column
            prop="bulletinTitle"
            label="公告标题">
          </el-table-column>
          <el-table-column
            label="操作"
            width="180">
            <template slot-scope="text">
              <a @click="GetBulletData(text.row.autoId)">查看</a>
            </template>
          </el-table-column>
      </el-table>
      </div>
          <div class='d_title'>
              <div>
                  <h1>{{DetailData.bulletinTitle}}</h1>
                  <span>发布日期：{{GetDate(DetailData.publishDate)}}</span>
                  <span v-if="type!=99">阅读人数：{{DetailData.readNum}}</span>
              </div>
          </div>
          <BigImg v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></BigImg>
          <div class='d_detail_content'>
              <div style="padding: 24px 204px;">
                  <div @click="ClickBigImg" v-html='DetailData.bulletinContent'></div>
              </div>
          </div>
          <div v-if="fileList!==null&&fileList.length>0&&type!=99" class="fileListBox">
            <div style="height: 35px;width: 100%;border-bottom: 1px solid #f0f0f0;margin-bottom: 35px;"></div>
            <div v-for="(item,index) of fileList" :key="index">
              <a :href="'/fileserver/api/download/' + item.fileId">
                {{ item.fileName }}
              </a>
            </div>
          </div>
          <div v-if="fileList!==null&&fileList.length>0&&type==99" class="fileListBox">
            <div style="height: 35px;width: 100%;border-bottom: 1px solid #f0f0f0;margin-bottom: 35px;"></div>
            <div v-for="(item,index) of fileList" :key="index">
              <!-- <a target=_blank :href="GetPath(item.fileData)"> -->
              <a href="javascript:void(0)" @click="Download(item.fileName,item.fileData)">
                {{ item.fileName }}
              </a>
            </div>
          </div>
      </div>
        <div
          v-if="type == 10"
          class="z_detail_iframe"
          style="padding: 24px 0"
        >
          <!-- <iframe
            width="100%"
            hight="auto"
            frameborder="0"
            scrolling="auto"
            id="mainiframe"
            :src="iframeSrc2"
          ></iframe> -->
          <Winbulletin
             :TextList="{
                  prjId: iframeSrc,
              }"
        ></Winbulletin>
        </div>
        <div v-else-if="type == 1" class="z_detail_iframe" style="padding: 24px 0">
          <!-- <iframe
            width="100%"
            hight="auto"
            frameborder="0"
            scrolling="auto"
            id="mainiframe"
            :src="iframeSrc"
          ></iframe> -->
          <Bulletin
             :TextList="{
                  prjId: iframeSrc,
              }"
        ></Bulletin>
        </div>
    </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { GetById } from '@/api/article'
import BigImg from '../components/BigImg/bigimg.vue'
import Bulletin from '../components/BulletinTab/bulletin.vue'
import Winbulletin from '../components/WinBulletin/winbulletin.vue'
import moment from 'moment'
import
{ GetBulletinContent,
  GetBulletinTyContent,
  GetBulletin,
  GetNewsContent
} from '@/api/protal'
const columns = [
  {
    title: '公告标题',
    dataIndex: 'bulletinTitle'
  },
  {
    title: '操作',
    dataIndex: 'autoId',
    slots: { title: 'autoId' },
    scopedSlots: { customRender: 'autoId' }
  }
]
export default {
  data () {
    const value = '0'
    return {
      value,
      DetailData: {},
      fileList: [],
      showImg: false,
      isNotice: false,
      isResult: true,
      datetime1: '　',
      datetime2: '　',
      datetime3: '　',
      datetime4: '　',
      datetime5: '　',
      datetime6: '　',
      bulletinId1: '',
      bulletinId2: '',
      bulletinId3: '',
      bulletinId4: '',
      bulletinId5: '',
      bulletinId6: '',
      ChangeMentList: [],
      JGMentList: [],
      change: 0,
      changeJG: 0,
      columns,
      imgSrc: ''
    }
  },
  components: {
    BigImg,
    Winbulletin,
    Bulletin
  },
  computed: {
    articleId () {
      return this.$route.query.articleId
    },
    bulletinId () {
      return this.$route.query.bulletinId
    },
    newsId () {
      return this.$route.query.newsId
    },
    type () {
      return this.$route.query.type
    },
    iframeSrc () {
      return this.$route.query.prjId
    }
  },
  methods: {
    ...mapMutations(['SET_NAV_NAME']),
    Download (fileName, fileData) {
      const blob = this.base64ToBlob(fileData)
      var fileurl = window.URL.createObjectURL(blob)
      fetch(fileurl).then(res => res.blob()).then(blob => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.download = fileName
        document.body.appendChild(a)
        a.click()
      })
    },
    base64ToBlob (code) {
      // Base64一行不能超过76字符，超过则添加回车换行符。因此需要把base64字段中的换行符，回车符给去掉，有时候因为存在需要把加号空格之类的换回来，取决于base64存取时的规则。
      code = code.replace(/[\n\r]/g, '')
      var raw = window.atob(code)
      let rawLength = raw.length
      // 转换成pdf.js能直接解析的Uint8Array类型
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {type: 'application/pdf'})// 转成pdf类型
    },
    ViewBJ () {
      this.$router.push({
        path: '/detail',
        query: { type: 1, prjId: this.iframeSrc }
      })
    },
    ViewJG () {
      this.$router.push({
        path: '/detail',
        query: { type: 10, prjId: this.iframeSrc }
      })
    },
    GetBulletData (bulletinId) {
      let param = {
        autoID: bulletinId
      }
      GetBulletinContent(param).then((res) => {
        this.DetailData.publishDate = res.data.article.publishDate
        this.fileList = res.data.fileList
        this.DetailData.bulletinTitle = res.data.article.bulletinTitle
        this.DetailData.readNum = res.data.article.readNum
        this.DetailData.prjId = res.data.article.prjId
        // this.DetailData.content = res.data.content;
        this.DetailData.bulletinContent = res.data.article.bulletinContent.replace('<img', '<img data-tagname="authorizationExtension"')
        this.value = res.data.article.bulletinTypeId + ''
        this.changeid = res.data.article.autoId
        if (res.data.article.bulletinTypeId !== 20) {
          this.isNotice = true
        }
        this.buyBtnShow = false
        if (this.DetailData.prjId) {
          if (
            res.data.article.signUpEndDate &&
            res.data.article.signUpStartDate
          ) {
            let nowdate = new Date()
            let result = moment(nowdate).isBetween(
              res.data.article.signUpStartDate,
              res.data.article.signUpEndDate
            )
            if (result) {
              this.buyBtnShow = true
            }
          }
        }
      })
    },
    theDatebtn (start, end) {
      var date = new Date()
      var myDate = new Date(date).getTime()
      var startDate = new Date(start).getTime()
      var endDate = new Date(end).getTime()
      if (startDate > myDate) {
        this.Datebtn = 1
      } else if (startDate < myDate && endDate > myDate) {
        this.Datebtn = 2
      } else if (endDate < myDate) {
        this.Datebtn = 3
      }
    },
    viewImg () {
      this.showImg = false
    },
    ClickBigImg (e) {
      const tagName = e.target.dataset.tagname
      if (tagName === 'authorizationExtension') {
        // alert(e.target.src)
        this.showImg = true
        this.imgSrc = e.target.src
      }
    },
    GetDate (date) {
      var day = ''
      if (date) {
        day = date.slice(0, 10)
      }
      return day
    },
    GetData () {
      if (this.articleId) {
        if (this.type !== '99') {
          let param = {
            id: Number(this.articleId)
          }
          GetById(param).then((res) => {
            this.DetailData = res.data
            this.DetailData.publishdate = res.data.publishDate
            this.DetailData.readNum = res.data.readNum
            this.DetailData.bulletinTitle = res.data.title
            // this.DetailData.content = res.data.content;
            this.DetailData.bulletinContent = res.data.content.replace('<img', '<img data-tagname="authorizationExtension"')
            //   console.log(res);
          })
        } else {
          let param = {
            autoID: this.articleId
          }
          GetBulletinTyContent(param).then((res) => {
            this.DetailData = res.data
            this.DetailData.publishdate = res.data.publishDate
            this.DetailData.readNum = res.data.readNum
            this.DetailData.bulletinTitle = res.data.title
            this.DetailData.bulletinContent = res.data.content
            this.fileList = res.data.fileList
            //   console.log(res);
          })
        }
      } else if (this.bulletinId) {
        let param = {
          autoID: this.bulletinId
        }
        GetBulletinContent(param).then((res) => {
          console.log(res)
          this.DetailData = res.data.article
          this.fileList = res.data.fileList
          this.theDatebtn(res.data.article.signUpStartDate, res.data.article.signUpEndDate)
          this.value = res.data.article.bulletinTypeId + ''
          GetBulletin(res.data.article.prjId).then((res) => {
            for (var i = 0; i < res.data.length; i++) {
              console.log(res.data[i])
              if (res.data[i].bulletinTypeId === '21') {
                this.datetime1 = res.data[i].publishDate.substr(0, 10)
                this.bulletinId1 = res.data[i].autoId
              } else if (res.data[i].bulletinTypeId === '23') {
                this.change++
                if (this.change < 2) {
                  this.datetime2 = res.data[i].publishDate.substr(0, 10)
                  this.bulletinId2 = res.data[i].autoId
                  this.ChangeMentList.push(res.data[i])
                  this.changeid = res.data[i].autoId
                } else {
                  this.datetime2 = '共 ' + this.change + '个公告'
                  this.ChangeMentList.push(res.data[i])
                }
              } else if (res.data[i].bulletinTypeId === '22') {
                this.changeJG++
                if (this.changeJG < 2) {
                  this.datetime3 = res.data[i].publishDate.substr(0, 10)
                  this.bulletinId3 = res.data[i].autoId
                  this.JGMentList.push(res.data[i])
                  this.changeid = res.data[i].autoId
                } else {
                  this.datetime3 = '共 ' + this.changeJG + '个公告'
                  this.JGMentList.push(res.data[i])
                }
              } else if (res.data[i].bulletinTypeId === '25') {
                this.datetime4 = res.data[i].publishDate.substr(0, 10)
                this.bulletinId4 = res.data[i].autoId
              } else if (res.data[i].bulletinTypeId === '26') {
                this.datetime5 = res.data[i].publishDate.substr(0, 10)
                this.bulletinId5 = res.data[i].autoId
              } else if (res.data[i].bulletinTypeId === '24') {
                this.datetime6 = res.data[i].publishDate.substr(0, 10)
                this.bulletinId6 = res.data[i].autoId
              }
            }
          })
          if (res.data.article.bulletinTypeId !== '20') {
            this.isNotice = true
            if (res.data.article.prjId == null || res.data.article.prjId === '') {
              this.isNotice = false
            }
          }
        })
      } else if (this.newsId) {
        GetNewsContent(this.newsId).then((res) => {
          this.DetailData = res.data.article
          this.DetailData.publishdate = res.data.article.publishDate
          this.DetailData.bulletinTitle = res.data.article.title
          this.DetailData.readNum = res.data.article.readNum
          this.DetailData.bulletinContent = res.data.article.content
          console.log(this.DetailData)
        })
      }
    }
  },
  mounted () {
    this.GetData()
    if (this.type === '10') {
      this.isResult = false
      this.value = 10
    }
    if (this.type === '1') {
      this.$http.get('/ztbapi/api/Notoken/GetOnlineInquireZbBulletin?PrjId=' + this.$route.query.prjId).then((res) => {
        if (res.data.Body.Data && res.data.Body.Data.ZbInfoList.length > 0) {
          this.isResult = false
        }
      })
      this.value = 1
    }
  }
}
</script>

<style scoped>
.d_title{
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 24px;
    text-align: center;
}
.d_title span{
    display: inline-block;
    color: #595959;
    margin-bottom: 16px;
}
.d_title h1{
    margin-bottom: 8px;
}
</style>
<style lang="less">
.d_detail_content img {
    max-width: 1000px;
    height: auto;
    cursor: pointer;
}
.fileListBox {
    padding: 0 204px;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner .shixin{
  display: block!important;
  width: 0!important;
  height: 0!important;
  border: 10px solid transparent!important;
  border-top-color: #175ec6!important;
  position: absolute!important;
  bottom: -45%!important;
  left: 40%!important;
}
.Lastli .el-timeline-item__tail{
  display: none!important;
}

.el-timeline{
  transform: rotate(270deg);
}
.el-timeline-item__content{
    width: 100px!important;
    transform: rotate(90deg)!important;
    margin-left: -95px!important;
    position: relative!important;
    top: 10px!important;
}
.el-radio-button__inner{
    // margin: 0 15px!important;
    margin: 0 12.5px!important;
    border: 1px solid #dcdfe6!important;
    width:112px;
}
.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FFF!important;
    background-color: #175ec6!important;
    border-color: #175ec6!important;
    -webkit-box-shadow: -1px 0 0 0 #175ec6!important;
    box-shadow: -1px 0 0 0 #175ec6!important;
    position: relative!important;
    margin-top: -15px!important;
}
.Lastli .el-timeline-item__tail{
  display: none!important;
}
.el-timeline-item__tail{
  position: absolute!important;
  left: 4px!important;
  // height: 94px!important;
  height: 109px!important;
  margin-top: 28px!important;
  margin-left: 8px!important;
  border-left: 2px solid #E4E7ED!important;
}
.Lastli{
    padding: 0;
    height: 35px!important;
}
.el-timeline-item{
  // height: 121px;
  height: 137px;
  padding-bottom:0!important;
}
.DZJJ .el-timeline-item{
  height: 123px;
}
.cell{
  cursor: pointer!important;
}
</style>



// WEBPACK FOOTER //
// src/views/detail.vue